import { IconFont } from '@/components/IconFont'
import { selectNotification } from '@/store/notification/notification.slice'
import { Badge } from 'antd'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export default memo(function Notification() {
  const count = useSelector(selectNotification).count

  return (
    <>
      <Badge style={{ boxShadow: 'none' }} count={count} showZero={false} overflowCount={99}>
        <Link to={'/notification'}>
          <IconFont
            type={'icon-alarm'}
            style={{ fontSize: '20px', color: '#fff', verticalAlign: 'middle' }}
          />
        </Link>
      </Badge>
    </>
  )
})
